<script setup>
const variables = [
  {
    category: 'Customer Info',
    items: [
      {
        simple: '[name]',
        description: 'Customer name (manually modified in system)',
        example: 'Hello [name]! → Hello John (modified)',
      },
      {
        simple: '[original_name]',
        description: 'Customer original name (from LINE/WhatsApp)',
        example: 'Hi [original_name]! → Hi ジョン (original)',
      },
      {
        simple: '[first_name]',
        description: 'Customer first name',
      },
      {
        simple: '[last_name]',
        description: 'Customer last name',
      },
      {
        simple: '[email]',
        description: 'Customer email',
      },
      {
        simple: '[phone]',
        description: 'Customer phone number',
      },
      {
        simple: '[id]',
        description: 'Customer ID',
      },
    ],
  },
  {
    category: 'Agent Info',
    items: [
      {
        simple: '[agent_name]',
        description: 'Agent full name',
      },
      {
        simple: '[agent_first_name]',
        description: 'Agent first name',
      },
      {
        simple: '[agent_last_name]',
        description: 'Agent last name',
      },
      {
        simple: '[agent_email]',
        description: 'Agent email',
      },
    ],
  },
  {
    category: 'Other',
    items: [
      {
        simple: '[inbox_name]',
        description: 'Inbox name',
      },
      {
        simple: '[conversation_id]',
        description: 'Conversation ID',
      },
    ],
  },
];
</script>

<template>
  <div class="variables-help">
    <div class="text-sm mb-4" style="color: #4b5563">
      <p class="font-medium mb-2" style="color: #111827">
        💡 Available Variables
      </p>
      <p>Use variables to automatically insert customer/agent information:</p>
      <ul class="list-disc ml-5 mt-2 space-y-1">
        <li><strong>Simple format:</strong> [name], [email], [phone]</li>
        <li><strong>Both uppercase and lowercase work</strong></li>
      </ul>
    </div>

    <div v-for="category in variables" :key="category.category" class="mb-6">
      <h4
        class="text-sm font-semibold mb-2 flex items-center"
        style="color: #111827"
      >
        <span class="mr-2">
          <template v-if="category.category === 'Customer Info'">👤</template>
          <template v-else-if="category.category === 'Agent Info'">👨‍💼</template>
          <template v-else>📋</template>
        </span>
        <span>{{ category.category }}</span>
      </h4>

      <div class="space-y-2">
        <div
          v-for="variable in category.items"
          :key="variable.simple"
          class="rounded px-3 py-2 transition-colors"
          style="background: #f9fafb; border: 1px solid #f3f4f6"
        >
          <div class="flex items-start gap-2">
            <code
              class="text-xs px-2 py-0.5 rounded font-mono whitespace-nowrap"
            >
              <span>{{ variable.simple }}</span>
            </code>
            <div class="flex-1 min-w-0">
              <p class="text-xs" style="color: #6b7280">
                {{ variable.description }}
              </p>
              <p
                v-if="variable.example"
                class="text-xs mt-1 italic"
                style="color: #9ca3af"
              >
                {{ variable.example }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="mt-4 p-3 rounded"
      style="background: #fef3c7; border: 1px solid #fde68a"
    >
      <p class="text-xs font-medium mb-1" style="color: #92400e">
        🔑 Key Difference
      </p>
      <ul class="text-xs space-y-1" style="color: #92400e">
        <li>
          <strong>[name]</strong> - Shows the name you manually edited in the
          system
        </li>
        <li>
          <strong>[original_name]</strong> - Shows the original name from
          LINE/WhatsApp
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.variables-help {
  color: #111827;
}

.variables-help p,
.variables-help span,
.variables-help li,
.variables-help strong {
  color: #374151 !important;
}

code {
  @apply select-all;
  background: #ffffff !important;
  border: 1px solid #e5e7eb !important;
  color: #7c3aed !important;
}
</style>
